/* eslint-disable react-hooks/exhaustive-deps */

import { useDispatch, useSelector } from 'react-redux';
import Layout from '../../components/Layout';
import { useEffect, useRef } from 'react';
import { HeaderSlot, uniqueID } from '../../../utils/constants';
import { useParams } from 'react-router-dom';
import { getOrderDetail } from '../../../store/reducers/order';
import { cleanText, encodeValue, isEmptyData } from '../../../utils/helper';
import useNavigation from '../../../hook/useNavigation';
import Loader from '../../../components/Loader';
import DetailTransaction from '../../components/Orders/Detail/DetailTransaction';
import OrderSummary from '../../components/Orders/Detail/OrderSummary';
import { setLayout } from '../../../store/reducers/layout';
import DeliveryLocation from '../../components/Orders/Detail/DeliveryLocation';
import PaymentMethod from '../../components/Orders/Detail/PaymentMethod';
import PaymentSummary from '../../components/Orders/Detail/PaymentSummary';
import FooterAction from '../../components/Orders/Detail/FooterAction';
import { RelativeHeader } from '../../components/Header';
import DetailStore from '../../components/Orders/Detail/DetailStore';
import RatingComponent from '../../components/Orders/Detail/RatingComponent';
import TableNumber from '../../components/Outlet/TableNumber';

const Detail = () => {
	const { id } = useParams();

	const dispatch = useDispatch();
	const navigate = useNavigation();
	const { loading: isLoadingOrderDetail, detail } = useSelector((store) => store?.order);
	const fetchAttemptedRef = useRef(false);
	const orderType = cleanText(detail?.orderType);

	const handleGetOrderDetail = async () => {
		dispatch(
			getOrderDetail({
				unquieid: uniqueID,
				orderNumber: id,
			}),
		);
	};

	useEffect(() => {
		dispatch(
			setLayout({
				minScrollHeight: 100,
			}),
		);
	}, []);

	useEffect(() => {
		if (!id) return;
		handleGetOrderDetail();
	}, [id]);

	useEffect(() => {
		if (isLoadingOrderDetail) {
			fetchAttemptedRef.current = true;
		} else if (fetchAttemptedRef.current && isEmptyData(detail)) {
			navigate.push('/ufood-x/not-found');
		}
	}, [isLoadingOrderDetail, detail]);

	const isShowButtonPay = detail?.orderStatus === '2';
	const isShowRating = detail?.orderStatus === '4';
	const headerProps = {
		slots: {
			left: {
        content: HeaderSlot.BACK
      },
			center: {
        content: HeaderSlot.NAME,
        title: 'Order Detail',
        className: '!opacity-100 transform !translate-y-0 ml-2',
      },
		},
    parent: {
      border: {
        bottom: true,
      }
    }
	};
	const pageLoading = isLoadingOrderDetail;

	return (
		<Layout>
			{pageLoading && <Loader overlay className={'-mx-4 top-0'} />}
			<RelativeHeader {...headerProps} />
			<DetailTransaction />
			<DetailStore />
			<TableNumber tableNumber={detail?.order_table_number} orderType={orderType} />
			{isShowRating && <RatingComponent order={detail} />}
			<OrderSummary />
			<DeliveryLocation />
			<PaymentMethod />
			<PaymentSummary />
			<div className={`${isShowButtonPay && 'pb-8'}`} />
			<FooterAction />
		</Layout>
	);
};

export default Detail;
